import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import CONFIG from '@/config/config.ts';

// keep in sync with file public/env.json
type Response = {
  env: string;
  germanyDivisionLocationId: string;
  maintenance: string;
  oktaRedirectUrl: string;
  swedenDivisionLocationId: string;
};

type Return = {
  data: Response | undefined;
  isFetching: boolean;
  isPending: boolean;
};

export const useGetEnvConfig = (): Return => {
  const { data, isFetching, isPending } = useQuery<Response>({
    queryFn: async () => {
      const { data } = await axios.get<Response>('/env.json', {
        headers: { 'Cache-Control': 'no-cache' },
      });
      CONFIG.OKTA_REDIRECT_URL = data.oktaRedirectUrl;
      CONFIG.ENV = data.env ?? '';
      CONFIG.MAINTENANCE = data.maintenance === 'true';
      CONFIG.SWEDEN_DIVISION_LOCATION_ID = Number.parseInt(data.swedenDivisionLocationId, 10) ?? 0;
      CONFIG.GERMANY_DIVISION_LOCATION_ID =
        Number.parseInt(data.germanyDivisionLocationId, 10) ?? 0;
      return data;
    },
    queryKey: [QueryKeyEnum.ENV_CONFIG],
  });

  return {
    data: data,
    isFetching,
    isPending,
  };
};
